import axios from 'axios';
import ApiClient from '../ApiClient';

class BrainAssistantAPI extends ApiClient {
  constructor() {
    super('brain/assistants', { accountScoped: true });
  }

  // Match the FAQ/Knowledge wrap convention. storeFactory calls update(id, updateObj).
  // Rails wants params.require(:assistant).permit(:description).
  update(id, updateObj = {}) {
    const { id: _id, ...assistantData } = updateObj;
    return axios.patch(`${this.url}/${id}`, { assistant: assistantData });
  }

  // Used by BrainAssistantSwitcher prefetch path. Backend resource gained :show in Wave 5.
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }
}

export default new BrainAssistantAPI();
